<div id="down-box-{{id}}" class="down-box">
    <div class="m-box">
        <div class="title">文件下载</div>
        <div class="row">
            <span>邮箱</span>
            <input id="down-email-{{id}}" type="text">
        </div>
        <div id="#error" class="error"></div>
        <div class="foot">
            <div class="foot-button" sk-event.click='hide()'>取消</div>
            <div class="foot-button" sk-event.click='send({{id}})'>确定</div>
        </div>
    </div>
</div>